import Slice from "./Slice";
export * from "./actions";
// export * from "./selectors";
export * from "./types";
export const { startGetEducationItemsAction, successGetEducationItemsAction, showGetEducationItemsErrorAction, setEducationItemsAction, setDeleteEducationDataStatus, setUpdateEducationInfoStatus, setPostEducationDataStatus, } = Slice.actions;
